import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import API from "Signups/API";
import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { useSignups } from "Signups/state";
import { motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

import useHovering from "Utilities/Hooks/useHovering";

import HoverButton from "../HoverButton";

export default function ExtraSlotEntry({ slot }) {
  const [state, dispatch] = useSignups();
  const [isHovering, hoverProps] = useHovering();
  const [status, setStatus] = React.useState(null);
  const [showDeletePopover, setShowDeletePopover] = useState(false);
  const confirmationRef = useRef();

  const toggleDeletePopover = () => setShowDeletePopover(!showDeletePopover);

  const handleDeleteClick = () => {
    setStatus("loading");
    API.updateUserSignupSlots({
      signupListID: state.currentSignupList.ID,
      signupItemID: slot.signupItemID,
      userID: slot.connectedUserID,
      numberOfSlots: slot.newNumberOfSlotsAfterDelete,
      signedUpViaID: 5,
    })
      .post()
      .then((resp) => {
        setStatus(null);
        setShowDeletePopover(false);
        dispatch({
          type: "Other User Signup Updated",
          signupList: resp.signupList,
          allSignupLists: resp.allSignupLists,
        });
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err?.error));
        setStatus(null);
        setShowDeletePopover(false);
      });
  };

  return (
    <Wrapper {...hoverProps}>
      <Name>No name provided</Name>

      <span ref={confirmationRef}>
        <HoverButton
          icon={faTrashAlt}
          isHovering={isHovering || showDeletePopover}
          isActive={showDeletePopover}
          onClick={toggleDeletePopover}
        />
      </span>

      <FnrConfirmationPopover
        show={showDeletePopover}
        ref={confirmationRef}
        onClose={() => setShowDeletePopover(false)}
        message={`Are you sure you want to remove this slot from the Signup?`}
        button1={
          <FnrButton
            text="Yes please!"
            onClick={handleDeleteClick}
            color="red"
            loading={status === "loading"}
          />
        }
        color="red"
        style={{ maxWidth: 200, padding: 10 }}
      />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  font-size: 14px;
  font-style: italic;
  margin: 2px 0 2px 14px;
  display: flex;
  align-items: center;
`;

const Name = styled.div`
  cursor: default;
  margin-right: 3px;
  color: #333;
  font-weight: 400;
`;
